<template>
  <div>
    <router-link class="come-back" to="/admin/unit_type">
      <div></div>
      Вернуться назад
    </router-link>
    <h2 class="title_categories">{{ $route.query.type === 'edit' ? 'Редактирование типа подразделения' : 'Создание типа подразделения' }}</h2>
    <tricolor-line class="card_containet__tricolor"/>
    <form @submit.prevent="addUnitType">
      <div>
        <div class="content-sb">
          <p>Название<span>*</span></p>
          <input required placeholder="Введите название" type="text" name="title" v-model="form.title" class="input blue">
        </div>
        <div class="content-sb">
          <p>Приоритет</p>
          <input placeholder="Введите число" type="number" name="order" v-model="form.order" class="input blue">
        </div>
        <div class="content-sb">
          <p>Название</p>
          <input placeholder="Введите название (Англ)" type="text" name="title" v-model="form.title_eng" class="input blue">
        </div>
        <div class="content-sb">
          <p>Код<span>*</span></p>
          <input required placeholder="Введите код" type="text" name="title" v-model="form.code" class="input blue">
        </div>
      </div>

      <footer class="content-sb btns-create-form">
        <router-link to="/admin/unit_type" class="btn-white">Отмена</router-link>
        <input type="submit" class="btn-blue" :value="$route.query.type === 'edit' ? 'Изменить' : 'Сохранить'"/>
      </footer>
    </form>
  </div>
</template>

<script>
import TricolorLine from '@/components/TricolorLine'

export default {
  name: 'createUnitType',
  data () {
    return {
      form: this.$route.query.type === 'edit' ? this.$store.getters.getDetailUnitType : {
        title: '',
        title_eng: '',
        code: '',
        order: 0
      }
    }
  },
  methods: {
    addUnitType () {
      if (this.$route.query.type === 'edit') {
        this.$store.dispatch('editUnitType', this.form)
      }
    }
  },
  mounted () {
    if (this.$route.query.type === 'edit' && this.$store.getters.getDetailUnitType === null) {
      this.$router.push('/admin/unit_type')
    }
  },
  components: {
    TricolorLine
  }
}
</script>

<style lang="scss">
.btns-create-form {
  border-top: 1px solid #D5D6D9;
  padding-top: 2.5rem;
  margin-top: 2.5rem;
}

.content-sb {
  margin-bottom: 1.25rem;

  span {
    color: red;
  }
}

.select, .input {
  width: 33.75rem;
}
</style>
